export enum AgreementCode {
  /** STOREBRAND **/
  NORMAL_TARIFF = 999,
  UNWANTED_CUSTOMER = 996,
  PREPAY_TARIFF = 995,
  COLLECTIVE_TARIFF = 900,
  PARENT_COMPANY_CUSTOMER_TARIFF = 800,
  FFA_PROGRAM_TARIFF = 601,
  NORSKELBILFORENING_TARIFF = 555,
  STOREBRAND_TARIFF = 500,
  FRAM = 603,

  /** PARTNERS **/
  AFAG = 580,
  LEGEFORENINGEN = 581,
  TANNLEGEFORENINGEN = 582,
  VETERINARENE = 583,
  ECONA = 584,
  NATURVITERNE = 587,
  LEKTORLAGET = 588,
  PSYKOLOGFORENINGEN = 589,
  SAMFUNNSVITERNE = 590,
  SAMFUNNSOKONOMENE = 591,
  COOP = 420,
  DANSKE_BANK = 430,
  HUSEIERNE = 410,
}
